var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarParts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.94 8.66663C11.98 8.77329 12 8.88663 12 8.99996C12 9.55329 11.5533 9.99996 11 9.99996C10.4467 9.99996 10 9.55329 10 8.99996C10 8.73996 10.1 8.50663 10.26 8.32663C9.17377 7.8874 8.29139 7.05734 7.78667 5.99996H3.87333L4.56667 3.99996H7.33333C7.33333 3.53996 7.4 3.08663 7.52667 2.66663H4.33333C3.89333 2.66663 3.52667 2.94663 3.38667 3.33996L2 7.33329V12.6666C2 13.0333 2.3 13.3333 2.66667 13.3333H3.33333C3.7 13.3333 4 13.0333 4 12.6666V12H12V12.6666C12 13.0333 12.3 13.3333 12.6667 13.3333H13.3333C13.7 13.3333 14 13.0333 14 12.6666V8.21329C13.3 8.55329 12.56 8.67329 11.94 8.66663ZM5 9.99996C4.44667 9.99996 4 9.55329 4 8.99996C4 8.44663 4.44667 7.99996 5 7.99996C5.55333 7.99996 6 8.44663 6 8.99996C6 9.55329 5.55333 9.99996 5 9.99996Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 4.5,
    r: 3.5,
    fill: "#00C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 5L11 2H12L11.9167 3.5L11.8333 5H11.1667Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarParts);
export default __webpack_public_path__ + "static/media/icon-car-parts.ca1492e6754954423ece05feee706c56.svg";
export { ForwardRef as ReactComponent };